export const individualSettings = [
  'attributes.borderColor',
  'attributes.buttonBackgroundColor',
  'attributes.buttonColor',
  'attributes.buttonLink',
  'attributes.buttonLinkNewPage',
  'attributes.buttonPadding',
  'attributes.buttonRadius',
  'attributes.variant',
  'content',
];
export const commonSettingsWrapperLevel = [
  'attributes.childrenSpacing',
  'attributes.containerBackgroundColor',
  'attributes.containerPadding',
  'attributes.horizontalAlign',
];

export const commonSettingsButtonLevel = [
  'attributes.borderWidth',
  'attributes.buttonFontFamily',
  'attributes.buttonFontSize',
  'attributes.buttonLetterSpacing',
  'attributes.hasBorder',
  'attributes.mode',
  'attributes.size',
];

export const simpleChangeAttributes = [
  ...individualSettings,
  ...commonSettingsWrapperLevel,
];
